import { render, staticRenderFns } from "./view-noticias.vue?vue&type=template&id=4809223e"
import script from "./view-noticias.vue?vue&type=script&lang=js"
export * from "./view-noticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports